import React, {useEffect, useState} from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './List';

interface Props {
    appDetails: any
}

const Deploy: React.FC<Props> = (props) => {
    const [appDetails, setAppDetails] = useState(null)

    useEffect(() => {
        if (props && appDetails == null) {
            setAppDetails(props.appDetails)
        }
    }, [props])

    return (
        <Switch>
            <Route exact path="/apps/list/:appId/solo/deploy/list" component={() => appDetails && <List appDetails={appDetails} />} />
        </Switch>
    )
}


export default Deploy;
